@if (loading) {
  <myp-skeleton-loader extraContainerClass="m-t-10 m-b-50" type="line" width="20%" height="30px"></myp-skeleton-loader>
  <myp-skeleton-loader type="product-tile" height="250px" [number]="9" class="grid-container pad-10"></myp-skeleton-loader>
}
@if (!loading) {
  <div>
    @if (activeFilter.length > 0) {
      <div id="applied-filter-container" sticky sticky-offset-top="20" sticky-offset-bottom="20">
        @for (filter of activeFilter; track filter) {
          <span class="facet-filter">
            {{ filter.label }}
            <fa-icon icon="times" (click)="removeFilter(filter)"></fa-icon>
          </span>
        }
      </div>
    }
    <myp-exchange-list
      (itemTapped)="viewExchangeDetail($event)"
      [limit]="limit"
      [page]="page"
      [searchQuery]="query"
      [searching]="searching"
      [showSearch]="!showCategories"
      (keyUpChange)="keyUp($event)"
      [displayedCategory]="displayedCategory"
      [wares]="displayedWares"
      (clearSearchQuery)="clearSearch()"
    ></myp-exchange-list>
  </div>
}
